module.exports = __webpack_public_path__ + "static/media/tcwglobal_logo.1f608354.svg";